import { Suspense } from "react";
import CommonLoader from "@src/components/loader/CommonLoader";
import ErrorBoundary from "@src/pages/page-not-found/ErrorBoundary";

const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary>
    <Suspense
      fallback={
        <div
          style={{
            position: "relative",
            minHeight: "100vh",
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CommonLoader color="var(--primary-color)" />
        </div>
      }
    >
      {children}
    </Suspense>
  </ErrorBoundary>
);

export default LazyWrapper;
